<template>
    <div class="container-fluid">
        <img :src="mnbg" alt="Imagen de fondo" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;object-fit: cover;opacity: 0.05;z-index: -1;">
        <div class="row" style="margin-top: 150px">
            <div class="col-12">
                <div class="d-flex justify-content-center pb-5">
                    <img :src="banner" class="img-fluid w-100" style="max-height: 300px;">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-12">
                <div class="m-5">
                    <p class="description-md epilogue-semibold">
                        Taller Detalle
                    </p>
                    <p class="description-xxs epilogue-regular">
                        Lorem ipsum dolor sit amet consectetur. Commodo odio imperdiet cursus lectus enim nisl vitae ullamcorper nunc. Facilisis egestas fames dis nunc. Mauris sit non viverra diam aliquam mauris pretium. Hendrerit quam tortor egestas malesuada.a
                        Lorem ipsum dolor sit amet consectetur. Commodo odio imperdiet cursus lectus enim nisl vitae ullamcorper nunc. Facilisis egestas fames dis nunc. Mauris sit non viverra diam aliquam mauris pretium. Hendrerit quam tortor egestas malesuada.a
                        Lorem ipsum dolor sit amet consectetur. Commodo odio imperdiet cursus lectus enim nisl vitae ullamcorper nunc. Facilisis egestas fames dis nunc. Mauris sit non viverra diam aliquam mauris pretium. Hendrerit quam tortor egestas malesuada.a
                    </p>
                    <a class="btn btn-primary px-5 rounded-pill">
                        <p class="m-0 rounded-5 epilogue-bold">Saber más</p>
                    </a>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="m-5">
                    <img :src="magdamn" class="img-fluid w-100">
                </div>
            </div>
        </div>
        <div class="row d-flex align-items-center m-5 p-5 bg-light">
            <div class="col-md-3 col-12">
                <div class="d-flex">
                    <img :src="magdamn1" class="img-fluid">
                </div>
            </div>
            <Carousel class="col-md-9 col-12 p-0 m-0" :wrap-around="true" :autoplay="2500" :breakpoints="breakpoints">
                <Slide v-for="(card, index) in cards" :key="index" class="d-flex justify-content-center align-items-center flex-column">
                    <div class="">
                        <div class="bg-primary rounded-circle">
                            <img :src="people" class="m-3" style="max-width: 40px;">
                        </div>
                    </div>
                    <p class="text-center">
                        Lorem ipsum dolor sit amet consectetur. Faucibus ipsum aliquam in lectus quam iaculis nibh non vitae. Adipiscing m
                    </p>  
                </Slide>              
            </Carousel>
        </div>
    </div>

</template>

<script setup>
    import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
    import magdamn from "ASSETS/images/35"
    import mnbg from "ASSETS/images/vectormn"
    import magdamn1 from "ASSETS/images/36"

    import people from "ASSETS/icons/people"

    import banner from "ASSETS/images/34"

    const cards = [
		{ image: people, text: "Lorem ipsum dolor sit amet consectetur. Duis metus sapien platea ullamcorper. Sit cursus vivamus tellus ut aliquam sodales tincidunt. Eu felis et vestibulum c" },
		{ image: people, text: "Lorem ipsum dolor sit amet consectetur. Duis metus sapien platea ullamcorper. Sit cursus vivamus tellus ut aliquam sodales tincidunt. Eu felis et vestibulum c" },
		{ image: people, text: "Cultura y creatividad. Empatía y amor. Altruismo y trabajo colaborativo. Compromiso con el cambio social."  },
	]
    const breakpoints = {  
		200: {
			itemsToShow: 1,
		},    
		576: {
			itemsToShow: 1,
		},
		992: {
			itemsToShow: 3,
		},
	};


</script>

<style lang="scss" scoped>

</style>
